import { Star } from "lucide-react";

interface StarRatingProps {
  rating: number | null;
  count?: number;
  size?: number;
}

export const StarRating = ({ rating, count, size = 12 }: StarRatingProps) => {
  if (rating === null || rating <= 0) return null;
  const stars = Array.from({ length: 5 }, (_, i) => {
    const filled = rating >= i + 1;
    const half = !filled && rating >= i + 0.5;
    return (
      <Star
        key={i}
        className={`flex-shrink-0 ${
          filled
            ? "fill-amber-400 text-amber-400"
            : half
            ? "fill-amber-400/50 text-amber-400"
            : "text-muted-foreground/30"
        }`}
        style={{ width: size, height: size }}
      />
    );
  });

  return (
    <div className="flex items-center gap-1">
      <div className="flex items-center gap-0.5">{stars}</div>
      {count !== undefined && count > 0 && (
        <span className="text-[11px] text-muted-foreground">({count})</span>
      )}
    </div>
  );
};
